import { Logo } from "../ui/Logo";
import { FOOTER_COLUMNS, isExternalHref } from "../data/footer";
import { LINKS } from "../data/links";

const LEGAL_LINKS: { label: string; href: string }[] = [
  { label: "PRIVACY POLICY", href: LINKS.privacy },
  { label: "TERMS", href: LINKS.terms },
  { label: "TRUST DOC", href: LINKS.trust },
];

function FooterAnchor({
  href,
  children,
  className,
}: {
  href: string;
  children: React.ReactNode;
  className?: string;
}) {
  const external = isExternalHref(href);
  return (
    <a
      href={href}
      {...(external && { target: "_blank", rel: "noopener noreferrer" })}
      className={className}
    >
      {children}
    </a>
  );
}

export function Footer() {
  return (
    <footer className="bg-bg border-t border-dashed border-dash-d px-8 pt-16 pb-12">
      <div className="mx-auto max-w-[1280px]">
        <div className="grid grid-cols-[1.4fr_repeat(3,1fr)] gap-12 max-md:grid-cols-1 max-md:gap-9">
          <div>
            <Logo size={28} />
            <p className="mt-4.5 max-w-[300px] text-sm italic leading-relaxed text-td-2">
              An AI Chief of Staff for everyone who closes in chat.
            </p>
            <p className="mt-4.5 font-mono text-[11px] tracking-wide text-td-3">
              SF · NYC · REMOTE
            </p>
          </div>
          {FOOTER_COLUMNS.map((col) => (
            <div key={col.title}>
              <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-accent mb-3.5">
                {col.title}
              </div>
              <ul className="flex flex-col gap-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <FooterAnchor
                      href={link.href}
                      className="text-sm text-td-2 hover:text-td-1 transition-colors"
                    >
                      {link.label}
                    </FooterAnchor>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 pt-6 border-t border-dashed border-dash-d flex justify-between items-center flex-wrap gap-4 font-mono text-[11px] tracking-wider text-td-3">
          <span>© 2026 SIDESTACK INC · ALL RIGHTS RESERVED</span>
          <div className="flex gap-6">
            {LEGAL_LINKS.map((link) => (
              <FooterAnchor
                key={link.label}
                href={link.href}
                className="text-td-3 hover:text-td-1 transition-colors"
              >
                {link.label}
              </FooterAnchor>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
